import Alert from 'react-bootstrap/Alert'

function Message({ message, variant = 'warning' }) {
  return (
    <Alert variant={variant} className='d-flex align-items-center justify-content-center'>
      {message}
    </Alert>
  )
}

export default Message
